export const InfoIconGreen = ({ size = 51, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 51 51"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g clipPath="url(#clip0_info)">
      <circle
        cx="25.3793"
        cy="25.3793"
        r="25.3793"
        fill="#00C48C"
        fillOpacity="0.05"
      />
      <circle
        cx="25.3793"
        cy="25.3793"
        r="24.6293"
        stroke="#00C48C"
        strokeOpacity="0.1"
        strokeWidth="1.5"
      />
    </g>
    <path
      d="M27.25 34.5502C26.55 35.1402 25.42 35.1402 24.74 34.5502L23.16 33.2002C22.86 32.9502 22.29 32.7402 21.89 32.7402L20.19 32.7402C19.13 32.7402 18.26 31.8702 18.26 30.8102L18.26 29.1102C18.26 28.7102 18.05 28.1502 17.8 27.8502L16.45 26.2702C15.86 25.5702 15.86 24.4402 16.45 23.7602L17.8 22.1802C18.05 21.8802 18.26 21.3202 18.26 20.9202L18.26 19.2202C18.26 18.1602 19.13 17.2902 20.19 17.2902L21.89 17.2902C22.29 17.2902 22.85 17.0802 23.15 16.8302L24.73 15.4802C25.43 14.8902 26.56 14.8902 27.24 15.4802L28.82 16.8302C29.12 17.0802 29.69 17.2902 30.08 17.2902L31.83 17.2902C32.89 17.2902 33.76 18.1602 33.76 19.2202L33.76 20.9302C33.76 21.3202 33.96 21.8902 34.21 22.1802L35.56 23.7702C36.14 24.4602 36.14 25.5802 35.56 26.2702L34.21 27.8602C33.96 28.1602 33.76 28.7202 33.76 29.1102L33.76 30.8002C33.76 31.8602 32.89 32.7302 31.83 32.7302L30.1 32.7302C29.7 32.7302 29.14 32.9402 28.84 33.1902L27.25 34.5502Z"
      stroke="#00C48C"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M26 28.8701L26 24.0401"
      stroke="#00C48C"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M26.0055 21L25.9965 21"
      stroke="#00C48C"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <defs>
      <clipPath id="clip0_info">
        <rect width="50.7586" height="50.7586" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
